/**
 * Get Warehouse Doc type name by ID
 *
 * @param {integer} type - Warehouse Doc type ID
 *
 * @return {string}
 */
export function getWarehouseDocType(type) {
  switch (type) {
    case 1:
      return 'Przyjęcie zewnętrzne '
    case 2:
      return 'Wydanie zewnętrzne '
    case 3:
      return 'Przyjęcie wewnętrzne '
    case 4:
      return 'Rozchód wewnętrzny '
    default:
      return ''
  }
}
